import { useState } from "react";
import { useForm } from "react-hook-form";
import {
  EstadoPreventaEnum,
  ModulosEnumChoice, newRechazoGeneralSchema,
  ROUTER_PATHS
} from "@/shared";
import { useFetchMotivosRechazo, useUpdateAgendamiento } from "@/shared/actions/erp";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { useFetchPutPreagendamientoPymes } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";

interface FormMotivoRechazo {
  id: string
  motivo_rechazo: string
  observacion_cancelacion: string
  observaciones?: any | any[]
}

interface useModalRechazoSolicitudTecnicoProps {
  modulo: ModulosEnumChoice,
  option?: string,
  returnUrlFactibilidadCorp?: string
  gestionVenta?: boolean
  returnUrl?: string

}
export function useModalRechazoSolicitudTecnico({
  modulo = ModulosEnumChoice.PREAGENDAMIENTO,
  returnUrl = ROUTER_PATHS.mantenimientoOperaciones.solicitudTecnicoPymesNav,
}: useModalRechazoSolicitudTecnicoProps) {
  const [modalCancelar, setModalCancelar] = useState(false);
  const [dialogContentText, setDialogContentText] = useState<string | null>(null)
  const [labelMotivo, setLabelMotivo] = useState<string>("Motivo de rechazo")

  const navigate = useNavigate()

  ///* formulario
  const formRechazo = useForm<FormMotivoRechazo, any, FormMotivoRechazo>({
    resolver: yupResolver(newRechazoGeneralSchema)
  });

  const { reset } = formRechazo;

  ///* react query

  const {
    mutateAsync: mutateAsyncPreagendamiento
  } = useFetchPutPreagendamientoPymes({
    returnUrl,
    navigate
  })

  const {
    mutateAsync: mutateAsyncAgendamiento
  } = useUpdateAgendamiento({
    navigate,
    returnUrl,
  })

  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo,
    page_size: 100,
  });

  ///* handle
  const onConfirm = async (_form: FormMotivoRechazo) => {


    try {

      let resp: {
        code: number
      } = {
        code: 500
      }

      const values = formRechazo.getValues();

      switch (modulo) {

        case ModulosEnumChoice.PREAGENDAMIENTO_PYMES:

          resp = await mutateAsyncPreagendamiento({
            id: values.id,
            data: {
              //estado_preagendamiento: EstadoPreventaEnum.EN_ESPERA,
              solicitar_tecnico: false,
              flota_adicional: null,
              motivo_rechazo: values.motivo_rechazo,
              observaciones: {
                ...values.observaciones,
                observacion_cancelacion_tecnico: values.observacion_cancelacion ?? 'N/A'
              }
            }
          });

          break;
        case ModulosEnumChoice.AGENDAMIENTO:

          resp = await mutateAsyncAgendamiento({
            id: values.id,
            data: {
              estado_agendamiento: EstadoPreventaEnum.FINALIZADO,
              solicitar_tecnico: false,
              flota_adicional: null,
              motivo_rechazo: values.motivo_rechazo,
              observaciones: {
                ...values.observaciones,
                observacion_cancelacion: values.observacion_cancelacion ?? 'N/A'
              }
            }
          });

          break;

        default:
          break;
      }

      if (resp.code === 200) {
        onClose()
      }

    } catch (error) {
      console.log('error hook rechazar:', error);

    }
  };

  const onClose = () => {
    reset({});
    setModalCancelar(false);
    returnUrl && navigate(returnUrl);
  };


  return {
    modalCancelar,
    setModalCancelar,
    formRechazo,
    motivosRechazoPaging: motivosRechazoPaging?.data,
    isLoadingMotivosRechazo,
    isRefetchingMotivosRechazo,
    onConfirm,
    onClose,
    reset,
    dialogContentText,
    setDialogContentText,
    labelMotivo,
    setLabelMotivo,

  };
}
